// extracted by mini-css-extract-plugin
export default {"Container":"StarRating_Container__xvcTU"};